export const noOp = (s)=>s;
